// Redux
import { Action, Result, AsyncResult, ApiAction } from '../index';
import api from '../redux-api';

// Utils
import { ACTIVITY_TYPES } from '../../utils/activity-log';
import createBatchLogger from '@/utils/batch-logger';

// Types
import { ActivityLogState } from './types/activity-log';
import Activity from '@/types/activity';

const INITIAL_STATE = {
  activityLogs: [],
  focusedActivityLogs: [],
  loading: false,
};

// Actions
const ADD_ACTIVITY: ApiAction = {
  type: 'connect/activity-log/add-activity',
  endpoint: 'activity-logs/',
};

const GET_ALL_ADVISORS_ACTIVITY: ApiAction = {
  type: 'connect/activity-log/get-all-advisors-activity',
  endpoint: 'users/activity-logs',
};

const GET_ADVISOR_ACTIVITY: ApiAction = {
  type: 'connect/activity-log/get-advisor-activity',
  endpoint: 'users/:id/activity-logs',
};

const RESET_ADVISOR_ACTIVITY: Action = {
  type: 'connect/activity-log/reset-advisor-activity',
};

export default function reducer(state: ActivityLogState = INITIAL_STATE, action: Action) {
  switch (action.type) {
    case GET_ALL_ADVISORS_ACTIVITY.type:
    case GET_ADVISOR_ACTIVITY.type: {
      return {
        ...state,
        loading: true,
      };
    }
    case `${GET_ALL_ADVISORS_ACTIVITY.type}_SUCCESS`: {
      const { logs, next } = action.data.data;

      return {
        ...state,
        activityLogs: action.params.next && state.activityLogs ? state.activityLogs.concat(logs) : logs,
        loading: false,
        nextToken: next,
      };
    }
    case `${GET_ADVISOR_ACTIVITY.type}_SUCCESS`: {
      const { logs, next } = action.data.data;

      return {
        ...state,
        focusedActivityLogs: action.params.next && state.focusedActivityLogs ? state.focusedActivityLogs.concat(logs) : logs,
        loading: false,
        nextTokenFocused: next,
      };
    }
    case `${GET_ALL_ADVISORS_ACTIVITY.type}_ERROR`:
    case `${GET_ADVISOR_ACTIVITY.type}_ERROR`: {
      return {
        ...state,
        loading: false,
      };
    }
    case RESET_ADVISOR_ACTIVITY.type: {
      return {
        ...state,
        focusedActivityLogs: [],
        nextTokenFocused: null,
      };
    }
    default: {
      return state;
    }
  }
}

const postBatch = (logs: { type: string; values: any }[]) => api.post(ADD_ACTIVITY, null, { logs });

const sendActivityLog = createBatchLogger(postBatch);

// Action Creators
export const addSearchItemLog =
  (id: string, type: string, source: string, dest: string): AsyncResult<void> =>
  () => {
    const body = {
      type: ACTIVITY_TYPES.ADD_SEARCH_ITEM,
      values: {
        id,
        type,
        source,
        dest,
      },
    };

    return sendActivityLog(body);
  };

export const getAllAdvisorsActivity =
  (nextToken?: string): AsyncResult<Activity[]> =>
  () => {
    const params: any = {};

    if (nextToken) {
      params.next = nextToken;
    }

    return api.get(GET_ALL_ADVISORS_ACTIVITY, params);
  };

export const getAdvisorActivity =
  (id: string, nextToken?: string): AsyncResult<Activity[]> =>
  () => {
    const params: any = {
      id,
    };

    if (nextToken) {
      params.next = nextToken;
    }

    return api.get(GET_ADVISOR_ACTIVITY, params);
  };

export const resetAdvisorActivity = (): Result<void> => dispatch => {
  dispatch(RESET_ADVISOR_ACTIVITY);
};
